export default String.raw`
$(document).ready(function() {
    const popupBanner = document.querySelector('.popup-timer-js');
    if (!popupBanner) {
        return;
    }

    const currentDate = new Date(Date.now());
    let popupBannerDaysDifference;
    if (__popupBannerDaysDiff) {
        popupBannerDaysDifference = parseInt(__popupBannerDaysDiff);
    } else {
        popupBannerDaysDifference = 30;
    }
    let popupBannerDaysDiff;
    let isPopupBannerSetDate = false;

    $.each(document.cookie.split(/; */), function()  {
        const cookies = this.split('=');
        if(cookies[0] == 'PopupBannerShowDate') {
            isPopupBannerSetDate = true;
            const popupBannerDate = new Date(cookies[1]);
            popupBannerDaysDiff = (currentDate.getTime() - popupBannerDate.getTime())  / (1000 * 3600 * 24); 
        }
    });
    
    if(isPopupBannerSetDate == false || (popupBannerDaysDiff && popupBannerDaysDiff >= popupBannerDaysDifference)) {
        document.cookie = "PopupBannerShowDate=" + currentDate;
        popupBanner.showModal();
    }
});
`